import { useEffect, useRef } from 'react'
import { Link, getRouteApi } from '@tanstack/react-router'
import { Alert, AuthCard } from '../components/ui'
import { useConfirmEmail } from '../lib/session'

const route = getRouteApi('/confirm-email')

// Le garde `sent` evite le double envoi du mode strict de React en developpement.
export default function ConfirmEmailPage() {
  const { userId, token } = route.useSearch()
  const confirm = useConfirmEmail()
  const sent = useRef(false)

  useEffect(() => {
    if (sent.current || userId === '' || token === '') {
      return
    }

    sent.current = true
    confirm.mutate({ userId, token })
  }, [confirm, userId, token])

  const invalidLink = userId === '' || token === ''

  return (
    <AuthCard title="Confirmation de l'adresse e-mail">
      {invalidLink && <Alert>Ce lien est incomplet. Copiez-le en entier depuis l'e-mail recu.</Alert>}
      {confirm.isPending && (
        <p className="text-sm text-neutral-600 dark:text-neutral-400">Confirmation en cours...</p>
      )}
      {confirm.isError && <Alert>{confirm.error.message}</Alert>}
      {confirm.isSuccess && (
        <Alert tone="success">Votre adresse est confirmee. Vous pouvez vous connecter.</Alert>
      )}

      <p className="mt-6 text-center text-sm">
        <Link to="/login" className="font-medium underline underline-offset-4">
          Aller a la connexion
        </Link>
      </p>
    </AuthCard>
  )
}
